module.exports = __webpack_public_path__ + "static/img/cart-icon.f85c03c1.png";